export async function getLocalSynchronous(db) {
    const row = await db.get('PRAGMA synchronous');
    return row.synchronous === 0 ? 'off' : row.synchronous === 1 ? 'normal' : 'full';
}
/** Sets `PRAGMA synchronous` on the writer connection and returns the previous mode. */
export async function setLocalSynchronous(db, mode) {
    const previous = await getLocalSynchronous(db);
    await db.execute(`PRAGMA synchronous = ${mode.toUpperCase()}`);
    return previous;
}
export async function getLocalJournalMode(db) {
    const row = await db.get('PRAGMA journal_mode');
    return row.journal_mode;
}
//# sourceMappingURL=local-tuning.js.map